/* WJW 20: Search uses the same exact collection filter drawer. Filter URLs are
   generated by Shopify's search.filters; this does NOT rewrite filter pricing. */
(() => {
  'use strict';
  const page = 'body.template-search';
  function scope() { return document.querySelector(page); }
  function drawer() { return scope()?.querySelector('.mobile-collection-filter-drawer'); }
  function close() {
    const el=drawer(); if(!el)return;
    el.classList.remove('open'); el.setAttribute('aria-hidden','true');
    document.querySelectorAll('body.template-search [data-open-filter]').forEach(b=>b.setAttribute('aria-expanded','false'));
    document.body.classList.remove('mobile-collection-filter-open');
  }
  document.addEventListener('click', event=>{
    if(!scope() || !matchMedia('(max-width:749px)').matches)return;
    const open=event.target.closest('body.template-search [data-open-filter]');
    if(open){
      const el=drawer(); if(!el)return;
      event.preventDefault(); el.classList.add('open');el.setAttribute('aria-hidden','false');
      open.setAttribute('aria-expanded','true');document.body.classList.add('mobile-collection-filter-open');return;
    }
    if(event.target.closest('body.template-search .mobile-collection-filter-drawer [data-close-filter]')) {
      event.preventDefault();close();return;
    }
    const apply=event.target.closest('body.template-search .mobile-collection-filter-drawer [data-apply-price-filter]');
    if(apply){
      const box=apply.closest('[data-price-filter]');if(!box)return;
      const url=new URL(location.href);
      for(const [selector,param] of [['[data-price-min]',box.dataset.minParam],['[data-price-max]',box.dataset.maxParam]]) {
        if(!param)continue;
        const input=box.querySelector(selector);
        const val=input?.value.trim();
        if(val!=='' && val!=null && Number.isFinite(+val) && +val>=0) url.searchParams.set(param,String(Math.round(Number(val)*100)/100));
        else url.searchParams.delete(param);
      }
      url.searchParams.delete('page');location.assign(url.href);
    }
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&drawer()?.classList.contains('open'))close();});
})();
